import { SDK_CDN_URL } from '~/common/contants';
import App from './app';

type Props = {
  [key: string]: any;
};

!(function (): null {
  function onWindowLoad(data: Props) {
    const {
      selector,
      productId,
      dKey: deviceId,
      shop,
      mode = 'release',
    } = data;

    if (!selector || !productId) {
      console.error(
        `[ERROR]: script 태그에 selector 속성 혹은 product-id 속성을 지정해주세요.`
      );
      return;
    }

    const target = document.querySelector<HTMLElement>(selector);
    if (!target) {
      console.error(`[ERROR]: selector와 일치하는 요소가 없습니다.`);
      return;
    }

    if (!deviceId || !shop) {
      console.warn(
        `[WARNING]: shop 속성 혹은 d-key 속성이 없을 경우 제대로 동작하지 않을 수 있습니다`
      );
    }

    /* -------------------------------- 스타일 시트 추가 ------------------------------- */
    const stylesheet = document.createElement('link');
    stylesheet.rel = 'stylesheet';
    stylesheet.type = 'text/css';
    stylesheet.href =
      `${SDK_CDN_URL}/entries/${mode === 'release' ? mode : 'stage'}` +
      (shop ? `/assistant-${shop}` : `/assistant`) +
      '.css';
    document.head.append(stylesheet);
    /* -------------------------------------------------------------------------- */

    App.init(target, { ...data, mode });
  }

  function toCamelCase(str: string) {
    return str.replace(/-./g, (x) => x[1].toUpperCase());
  }

  const dataObject: Props = {};
  const attrList = document.currentScript.attributes;

  // get data attribute
  for (let i = 0; i < attrList.length; i++) {
    const attr = attrList.item(i);
    const attrName = attr.name;
    const regex = /^(data-).+/;

    if (regex.test(attrName) && attr.value) {
      let dataAttrName = toCamelCase(attrName.replace('data-', ''));
      dataObject[dataAttrName] = attr.value;
    }
  }

  if (document.readyState === 'complete') {
    // safari
    onWindowLoad(dataObject);
  } else {
    window.addEventListener('load', () => {
      onWindowLoad(dataObject);
    });
  }

  return;
})();
